import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation.js";
import React from "react";

/**
 * Dynamically load translation files pertaining to the dashboard module.
 * @return {*}
 */
export default function useTranslationDashboard() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/dashboard.json'),
    'fr': import('./locales/fr/dashboard.json')
  }), []);

  return useModuleTranslation('dashboard', imports);
}
